<template>
  <el-container class="body-container">
    <el-main class="body-main" id="bodyMain">
      <!-- <div class="body-header">
        <el-image :src="noticeBanner[0].picUrl" fit="cover" style="width: 100%;height: 152px;"></el-image>
      </div> -->
      <div style="display: flex;justify-content: center;">
        <div class="body-main_center">
          <div class="body-main_one">
            <div class="list-content" style="margin-bottom: 10px;margin-top: 10px;height: 434px;">
              <div class="list-title" @click="newList('new')">
                <div class="list-title_bold">动态新闻<span>/NEWS</span></div>
                <!-- <div class="list-title_more" >更多<i class="el-icon-arrow-right"></i></div> -->
              </div>
              <el-carousel height="220px" style="width: 390px;margin-left: 10px;">
                <el-carousel-item v-for="(item,index) in picUrls" :key="index">
                  <el-image :src="item.picUrl" fit="cover"></el-image>
                </el-carousel-item>
              </el-carousel>
              <div class="list-body">
                <el-skeleton animated :loading="news.length > 0?false:true" :throttle="500">
                  <template>
                    <div class="list-item" v-for="(item,index) in news" :key="index" @click="newDetail(item)">
                      <div>
                        <el-tag type="primary" v-show="item.flag = 'new'">NEW</el-tag>
                        {{ item.title | filterNew }}
                      </div>
                      <div>
                        {{ changeDay(item.publishTime) }}
                      </div>
                    </div>
                  </template>
                </el-skeleton>
              </div>
            </div>
            <div class="list-content" style="margin-bottom: 10px;height: 167px;">
              <div class="list-title" style="margin-bottom: 0;" @click="newList('notice')">
                <div class="list-title_bold">通知公告<span>/NOTICES</span></div>
                <!-- <div class="list-title_more">更多<i class="el-icon-arrow-right"></i></div> -->
              </div>
              <div class="list-body" style="min-height: 130px;">
                <el-skeleton animated :loading="news.length > 0?false:true" :throttle="500">
                  <template>
                    <div class="list-item" v-for="(item,index) in notices" :key="index" @click="newDetail(item)">
                      <div>
                        <el-tag type="primary" v-show="item.flag = 'new'">NEW</el-tag>
                        {{ item.title | filterNew }}
                      </div>
                      <div>
                        {{ changeDay(item.publishTime) }}
                      </div>
                    </div>
                  </template>
                </el-skeleton>
              </div>
            </div>
            <div class="list-content">
              <div class="list-title" style="margin-bottom: 0;" @click="goCanlender">
                <div class="list-title_bold">日程管理<span>/SCHEDULE</span></div>
                <!-- <div class="list-title_more">更多<i class="el-icon-arrow-right"></i></div> -->
              </div>
              <div class="list-body">
                <div class="list-item_canlendar">
                  <lunar-canlendar :double="false" @handleOne="clickOne"></lunar-canlendar>
                  <el-popover
                      placement="top-end"
                      width="320"
                      popper-class="main_right--popover"
                      v-model="popoverVisible"
                      ref="mainPopover"
                      @show="showPopover"
                      trigger="click">
                      <div v-show="form.type !== 'view'">
                        <el-radio-group style="margin-bottom: 5px;" v-model="form.scheduleType">
                          <el-radio-button label="schedule">日程</el-radio-button>
                          <!--<el-radio-button label="meeting">会议</el-radio-button>-->
                          <el-radio-button label="active">活动</el-radio-button>
                        </el-radio-group>
                        <el-form :model="form" label-width="70px" size="mini" class="table-form">
                          <el-form-item label="主题" required>
                            <el-input v-model="form.title"></el-input>
                          </el-form-item>
                          <el-form-item label="内容">
                            <el-input type="textarea" :rows="3" v-model="form.content"></el-input>
                          </el-form-item>
                          <el-form-item label="开始时间" required>
                            <el-date-picker
                              v-model="form.startTime"
                              type="datetime"
                              placeholder="选择开始时间"
                              @change="openSche">
                            </el-date-picker>
                          </el-form-item>
                          <el-form-item label="结束时间" required>
                            <el-date-picker
                              v-model="form.endTime"
                              type="datetime"
                              class="seletTime"
                              placeholder="选择结束时间"
                              :picker-options="{
                                disabledDate (time) {
                                  return time.getTime() < new Date(new Date(form.startTime).setHours(0, 0, 0, 0))
                                }
                              }"
                              @change="openSche">
                            </el-date-picker>
                          </el-form-item>
                          <el-form-item label="会议室" v-if="form.scheduleType == 'meeting'">
                            <el-select v-model="form.meetingRoomId">
                              <el-option v-for="(item,index) in meetingRoomList" :key="index" :label="item.meetingRoomName||''" :value="item.id"></el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item label="参与人">
                            <div style="border: 1px solid #DCDFE6;border-radius: 4px;padding: 0 5px;">
                              <div style="display: flex;font-size: 10px;flex-wrap: wrap;">
                                <i class="el-icon-circle-plus-outline cursor_point" @click="openUser" style="color: #C0C4CC;line-height: 24px;font-size:14px"></i>
                                <el-tag @close="handleCloseTag(index)"
                                  v-for="(item,index) in form.personData" type='plain' size="mini" :key="index" closable>
                                  {{item.name}}
                                </el-tag>
                              </div>
                            </div>
                          </el-form-item>
                          <el-form-item label="提醒时间">
                            <el-select v-model="form.teminderTypeCode" multiple>
                              <el-option v-for="(item,index) in remindSelect" :disabled="isOptionDisabled(item.value)" :key="index" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                          </el-form-item>
                        </el-form>
                      </div>
                      <div v-show="form.type == 'view'" style="padding: 12px;font-size: 10px;">
                          <el-form :model="form" label-width="60px" size="mini" class="table-form form-one">
                            <el-tag color="#b72024" size="small" style="margin-bottom: 10px; background-color:transparent;border:0px"> <span style="color:#b40005;font-size:16px">{{ form.scheduleType == 'meeting'?'会议':form.scheduleType == 'schedule'?'日程':'活动' }}</span></el-tag>
                            <el-form-item label="主题">
                              <div style="font-size: 10px;height: 28px;color:#0a131a">{{ form.title }}</div>
                            </el-form-item>
                            <el-form-item label="内容">
                              <div style="font-size: 10px;line-height: 20px;min-height: 28px;color: rgb(10, 19, 26);margin-top: 4px;">{{ form.content }}</div>
                            </el-form-item>
                            <el-form-item label="开始时间">
                              <div style="font-size: 10px;height: 28px;color:#0a131a">{{ changeDayTime(form.startTime) }}</div>
                            </el-form-item>
                            <el-form-item label="结束时间">
                              <div style="font-size: 10px;height: 28px;color:#0a131a">{{ changeDayTime(form.endTime) }}</div>
                            </el-form-item>
                            <el-form-item label="会议室" v-if="form.scheduleType == 'meeting'">
                              <div style="font-size: 10px;height: 28px;color:#0a131a" v-if="form.meetingRoomId">{{ meetingRoomList.find(item => item.id ==form.meetingRoomId).meetingRoomName  }}</div>
                            </el-form-item>
                            <el-form-item label="参与人">
                              <div style="padding: 0 5px;">
                                <div style="display: flex;font-size: 10px;flex-wrap: wrap;">
                                  <el-tag 
                                    v-for="(item,index) in form.personData" type='info' effect="plain" size="mini" :key="index">
                                    {{item.name}}
                                  </el-tag>
                                </div>
                              </div>
                            </el-form-item>
                            <el-form-item label="提醒时间">
                              <div style="font-size: 10px;height: 28px;color:#0a131a">{{ form.teminderTypeName }}</div>
                            </el-form-item>
                          </el-form>
                      </div>
                      <div style="text-align: right; margin: 0">
                        <el-button class="size_button_12" size="mini" v-show="form.type !== 'view'" @click="popoverVisible = false">取消</el-button>
                        <el-button class="size_button_12" size="mini" v-show="form.type == 'view'&&form.createUserId==user.userInfoId" @click="deleteCanlender">删除</el-button>
                        <el-button class="size_button_12" size="mini" v-show="form.type == 'view'&&form.createUserId!=user.userInfoId" @click="acceptData('disagree')">拒绝</el-button>
                        <el-button type="primary" class="size_button_12" size="mini" v-show="form.type == 'view'&&form.createUserId!=user.userInfoId" @click="acceptData('agree')">接受</el-button>
                        <el-button type="primary" class="size_button_12" size="mini" v-show="form.type == 'view'&&form.createUserId==user.userInfoId" @click="updateCanlenderStatus">编辑</el-button>
                        <el-button type="primary" class="size_button_12" size="mini"v-show="form.type !== 'view'" @click="sureCanlender">保存</el-button>
                      </div>
                      <el-button slot="reference" circle class="canlendar-option" @click="clearShow" icon="el-icon-plus"></el-button>
                  </el-popover>
                  <div v-show="day == item.date" style="height: 100px;overflow-y: auto;" v-for="(item,index) in scheduleList" :key="index">
                      <div class="canlendar-item" v-for="(t,i) in item.items" :key="i" @click="updateCanlender(t)">
                        <div class="canlendar-left">
                          <div v-show="i === 0">{{ item.date.slice(8,10) }}</div>
                        </div>
                        <div class="canlendar-right">
                          <div class="canlendar-content">
                          {{ t.scheduleType == 'meeting'?'会议':t.scheduleType == 'schedule'?'日程':'活动' }} <span style="margin: 0 5px;">|</span> {{ t.title }}
                          </div>
                          <div class="canlendar-day">
                            <span>{{ changeDayTime(t.startTime).slice(10,16) }}</span> ~
                            <span>{{ changeDayTime(t.endTime).slice(10,16) }}</span>
                          </div>
                        </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="body-main_two">
            <div class="body-main_left">
              <!-- <div class="body-model">
                <div class="body-model_special">
                  <div style="font-weight: 500;">感谢您陪伴汉森制药<span style="color: #058ACF;font-size:20px;padding: 0 10px;font-weight: 700;">{{ entryDay }}</span>天</div>
                  <div class="body-special_avatar">
                    <el-avatar src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"></el-avatar>
                    <div>
                        <div>{{ headInfo.userInfoResp.userName }} <span>{{ headInfo.userInfoResp.userCode }}</span></div>
                        <div>{{ headInfo.userInfoResp.dept }}</div>
                        <div>{{ headInfo.userInfoResp.position }}</div>
                    </div>
                  </div>
                </div>
                <div class="body-model_block">
                  <div>{{ headInfo.restDays || 0 }}</div>
                  累计调休可用(天)
                </div>
                <div class="body-model_block">
                  <div>{{ headInfo.overtimeMonth || 0  }}</div>
                  本月加班(小时)
                </div>
                <div class="body-model_block" style="margin-right: 0;">
                  <div>{{ headInfo.unCheckQuantity || 0  }}</div>
                  本月考勤异常(次)
                </div>
              </div> -->
              <div class="body-message">
                <div style="background-color: #fff;margin-bottom: 10px;padding: 15px;height: 434px;border-radius: 8px;">
                  <div class="list-title" @click="goFlow()">
                    <div class="list-title_bold">我的待办<span>/TODO</span></div>
                    <!-- <div class="list-title_more">更多<i class="el-icon-arrow-right"></i></div> -->
                  </div>
                  <div class="body-message_title">
                    <el-radio-group v-model="messageType" @change="changeRadio">
                      <el-radio-button label="待办">待办<span>{{ headInfo.todoCount }}</span></el-radio-button>
                      <el-radio-button label="已办">已办<span>{{ headInfo.doneCount }}</span></el-radio-button>
                      <el-radio-button label="待阅">待阅<span>{{ headInfo.toReadCount }}</span></el-radio-button>
                      <el-radio-button label="已阅">已阅<span>{{ headInfo.readCount }}</span></el-radio-button>
                    </el-radio-group>
                  </div>
                  <el-table :data="tableData" class="body-message_table" height="350"
                  v-loading="todoLoading"
                    :header-cell-style="{'border-bottom': 'none','color': '#83898f','font-size': '13px','font-weight': '500','padding-top': '8px','padding-bottom': '8px'}"
                    :row-key="rowKey"
                    style="width: 100%">
                    <!-- <el-table-column
                      prop="status"
                      label="状态"
                      align="center"
                      class-name="message_table--status"
                      width="80">
                      <template slot-scope="scope">
                        <el-tag type="warning" v-if="scope.row.status === 20">办理中</el-tag>
                        <el-tag type="warning" v-else-if="scope.row.status === 25">撤回</el-tag>
                        <el-tag type="warning" v-else-if="scope.row.status === 10">草稿</el-tag>
                        <el-tag type="warning" v-else-if="scope.row.status === 35">已驳回</el-tag>
                        <el-tag type="warning" v-else-if="scope.row.status === 40">取消</el-tag>
                        <el-tag type="warning" v-else-if="scope.row.status === 45">撤销</el-tag>
                        <el-tag type="warning" v-else-if="scope.row.status === 60">异常</el-tag>
                        <el-tag type="success" v-else-if="scope.row.status === 50">审核通过</el-tag>
                        <el-tag type="success" v-else>已处理</el-tag>
                      </template>
                    </el-table-column> -->
                    <el-table-column
                      prop="flowName"
                      label="流程标题"
                      :show-overflow-tooltip="false">
                      <template slot-scope="scope">
                        <el-tooltip effect="dark" :content="scope.row.flowStr1" placement="top-start">
                          <div class="cursor_point process" style="text-align: center;" @click="goFlowDetail(scope.row)">{{ scope.row.flowStr1 | filterFlowName }}</div>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="typeName"
                      label="流程类型"
                      align="center"
                      width="100">
                    </el-table-column>
                    <el-table-column
                      prop="processNo"
                      label="单据编号"
                      align="center"
                      width="130">
                    </el-table-column>
                    <el-table-column
                      prop="applyUserName"
                      label="发起人"
                      align="center"
                      width="100">
                    </el-table-column>
                    <el-table-column
                      prop="applyTime"
                      label="发起时间"
                      :formatter="changeTime"
                      align="center"
                      width="180">
                    </el-table-column>
                  </el-table>
                </div>
                <div style="display: flex;gap: 10px;">
                   <div style="background-color: #fff;margin-bottom: 10px;padding: 15px;height: 280px;flex: 1;border-radius: 8px;">
                    <div class="list-title" @click="goProcess">
                      <div class="list-title_bold">常用应用<span>/PROCESS</span></div>
                      <!-- <div class="list-title_more">更多<i class="el-icon-arrow-right"></i></div> -->
                    </div>
                  
                    <el-row :gutter="20" style="padding: 0 15px;">
                      <div v-if="applyList.length === 0" style="padding-top: 10px;">
                        <div class="list-none-image">
                          <img src="@/assets/images/nodata.png" style="width: 160px; height: 120px;"></img>
                        </div>
                        <div class="list-none-font">暂时没有应用</div>
                      </div>
                      <el-col class="apply-list" :span="12" style="padding-bottom: 16px;" v-for="(item,index) in applyList" :key="index">
                        <div class="apply-item cursor_point" @click="goApp(item)">
                          <img style="height: 40px;margin-left: 20px;margin-top: 25px;" :src="global.BASE_URL + item.systemIcon" fit="cover"></img>
                          <div style="line-height: 20px;display: flex;align-items: center;font-size: 12px;">{{ item.systemName }}</div>
                        </div>
                      </el-col>
                    </el-row>
                 </div>


                 <div style="background-color: #fff;margin-bottom: 10px;padding: 15px;height: 280px;flex: 1;border-radius: 8px;">
                      <div class="list-title_bold" style="position:absolute;background-color: #fff;z-index:50" @click="goMyMeetig">智能会议<span>/MEETING</span> 
                        
                      </div>
                            
                    <el-carousel v-if="meetingDatas && meetingDatas.length > 0" trigger="click" height="280px" arrow="hover" :loop="false" :autoplay="false" >
                        <el-carousel-item v-for="(item,index) in meetingDatas" :key="item"  style="height: 100%" >
                            <!-- <el-button type="text" style="position: absolute;top: 00px;right: 0px;" @click="goMeetigDetail(item)">进入应用</el-button> -->
                          <div class="meeting-box"  @click="goMeetigDetail(item)">
                            <span class="meeting-title">{{ item.meetingTheme }}</span>
                            <span class="meeting-text">
                            
                              <span style="color: rgb(169, 184, 191);">
                                  <i class="el-icon-time"></i> 时间：</span>
                              {{ formateDateTime(item.startTime)}} - {{ formateDateTime(item.endTime)}}
                            </span>
                            <span class="meeting-text">
                              <span style="color: rgb(169, 184, 191);">
                               <i class="el-icon-office-building"></i> 会议室：</span> {{ item.meetingRoomName }}
                            </span>
                            <span class="meeting-text">
                              <span style="color: rgb(169, 184, 191);">
                               <i class="el-icon-location-outline"></i>  地址：</span>{{ item.meetingAddress }}
                            </span>
                            <span class="meeting-text">
                        
                              <span style="color: rgb(169, 184, 191);"> 
                                 <i class="el-icon-user"></i>  参会人数：
                                </span>{{ item.peopleNum }}
                            </span>
                          </div>
                          <div v-if="(item.reply && item.reply!='') || item.staffType == 'f'"  style="display: flex;gap: 5px;position: fixed; bottom: 35px;margin: 15px;">
                            <div class="sure-button-box "  size="mini" disabled>已确认参加</div>
                          </div>
                          <div v-else style="display: flex;gap: 5px;position: fixed; bottom: 35px;margin: 15px;">
                            <el-button type="primary" size="mini" @click="staffReply(item,'yes')">参加</el-button>
                            <el-button type="primary"  size="mini" @click="openRefuseReply(item)">不参加</el-button>
                            <!-- <el-button type="primary"  size="mini" @click="openEntrustReply(item)">委托</el-button> -->
                          </div>
                        </el-carousel-item>
                      </el-carousel>

                        <div v-else style="padding-top: 60px;">
                          <div class="list-none-image">
                            <img src="@/assets/images/nodata.png" style="width: 160px; height: 120px;"></img>
                          </div>
                          <div class="list-none-font">暂时没有会议</div>
                          <div style="width: 100%;display: flex;justify-content: center;margin-top: 10px;">
                             <el-button type="primary" size="mini" @click="toBookMeeting">新建会议</el-button>
                          </div>
                          
                        </div>

                      </div>
                </div>
                <div style="background-color: #fff;padding: 15px;height: 402px;border-radius: 8px;">
                  <div class="list-title"  @click="goAdd()">
                    <div class="list-title_bold">常用流程<span>/PROCESS</span></div>
                    <!-- <div class="list-title_more">更多<i class="el-icon-arrow-right"></i></div> -->
                  </div>
                  <el-row :gutter="20">
                    <el-col :span="4" style="margin-left: 16.5px;margin-bottom: 26px;cursor: pointer;"  v-for="(item,index) in flowList" :key="index">
                      <el-card style="width: 126px;text-align: center;border: none;" @click.native="goAdd(item)" shadow="never" class="card-item">
                        <svg v-if="item.picUrl&&item.picUrl.startsWith('#hs-icon')"  class="hs-icon" style="font-size:50px;margin-top: 12px;" aria-hidden="true">
                          <use :xlink:href="item.picUrl"></use>
                        </svg>
                        <el-avatar v-else fit="fill" :size="50"  :style="{'--background-color':item.background,'--shadow-color':item.shadow}" :src="global.BASE_URL_2971 +(item.picUrl||'/upload/2025/08/c0124b0d-5b1b-486e-9b16-06be52c3c2da.png')"></el-avatar>
                        <el-tooltip class="item" effect="dark" :content="item.flowName" placement="top-start">
                          <div style="font-size: 12px;margin-top: 10px;">{{ item.flowName | filterTitle }}</div>
                        </el-tooltip>
                      </el-card>
                    </el-col>
                    <el-col :span="4" style="margin-left: 16.5px;margin-bottom: 26px;cursor: pointer;">
                      <el-card style="width: 126px;text-align: center;border: none;" @click.native="goAdd()" shadow="never" class="card-item">
                        <el-avatar fit="fill" :size="50"  :style="{'--background-color':'#F0F2F5','--shadow-color':'rgba(240, 242, 245,.3)'}" icon="el-icon-more"></el-avatar>
                        <el-tooltip class="item" effect="dark" content="更多" placement="top-start">
                          <div style="font-size: 12px;margin-top: 10px;">更多</div>
                        </el-tooltip>
                        <!-- <el-button type="primary" @click="goAdd(item)" style="position: absolute;bottom: 10px;left: 25px;font-size: 10px;" size="mini" >发起流程</el-button> -->
                      </el-card>
                    </el-col>
                  </el-row>
                </div>

                
              </div>
            </div>
          </div>
        </div>
      </div>
       
      <person-dept-tree :multiple="true" :initData="this.form.personData.map(item => item.id).join(',')" :config="userSelectConfig" v-if="userSelectConfig.dialogVisible" @cancelData="cancelData" @choiceData="confirmUser" :users="$store.state.allUser"></person-dept-tree>
      <person-dept-tree :multiple="false" :config="entrustUserSelectConfig" v-if="entrustUserSelectConfig.dialogVisible"  @choiceData="confirmEntrustUser" :users="$store.state.allUser"></person-dept-tree>
    </el-main>
    <!-- <div class="footCss"></div> -->

    <el-dialog :title="'拒绝参会回执'" :append-to-body="true" :visible.sync="replyDialogFormVisible" width="30%">
        <el-container>
          <el-main class="table-main">
            <el-form :model="form" label-width="80px">
              <el-form-item label="不参会原因 " prop="reason">
                <el-input v-model="meetingForm.reason"  maxlength="200"></el-input>
              </el-form-item>
            </el-form>
          </el-main>
          <el-footer class="table-footer">
            <el-button @click="replyDialogFormVisible = false" class="btnPass">取 消</el-button>
            <el-button type="primary" @click="refuseReply()" class="btnPass left">确 定</el-button>
          </el-footer>
        </el-container>
      </el-dialog>
      <el-dialog :title="'参会委托'" :append-to-body="true" :visible.sync="entrustDialogFormVisible" width="30%">
        <el-container>
          <el-main class="table-main">
            <el-form :model="form" label-width="80px">
              <el-form-item label="委托人员" prop="entrustStaffName">
                <el-input v-model="meetingForm.entrustStaffName" @focus="entrustUserSelectConfig.dialogVisible = true" placeholder="请选择委托人员"></el-input>
              </el-form-item>
            </el-form>
          </el-main>
          <el-footer class="table-footer">
            <el-button @click="entrustDialogFormVisible = false" class="btnPass">取 消</el-button>
            <el-button type="primary" @click="entrustReply()" class="btnPass left">确 定</el-button>
          </el-footer>
        </el-container>
      </el-dialog>
  </el-container>
</template>

<script>
import LunarCanlendar from './components/LunarCanlendar.vue';
import personDeptTree from '@/components/Tree/personDeptTree.vue'
import { getUserColor } from '@/assets/common/common.js'
import { data } from 'jquery';
import { Solar } from 'lunar-javascript'
import moment from 'moment'
import { encryptDes } from "@/utils/des";
import Cookies from 'js-cookie';

export default {
  name: 'mian',
  components: {
    LunarCanlendar,
    personDeptTree,
  },
  data() {
    return {
      moment,
      headInfo: {
        userInfoResp:{}
      },
      noticeBanner: [],
      news: [
        // {
        //   flag: 'new',
        //   title: '四季度业务评比竟赛收官喜报',
        //   time: '2025-01-20'
        // },
        // {
        //   title: '三季度业务评比竟赛收官喜报',
        //   time: '2025-01-15'
        // },
        // {
        //   title: '二季度业务评比竟赛收官喜报',
        //   time: '2025-01-05'
        // },
        // {
        //   title: '一季度业务评比竟赛收官喜报',
        //   time: '2025-01-01'
        // },
      ],
      notices: [
        // {
        //   flag: 'new',
        //   title: '关于2024年国庆节放假安排的通知',
        //   time: '2024-09-20'
        // },
        // {
        //   title: '关于2024年端午节放假安排的通知',
        //   time: '2025-05-01'
        // },
      ],
      picUrls: [
        {
          src:'https://cdnjs0001.ausnutria.com/file/updata/41bec8be74f145668c4a890e288a58b8.jpg',
        },
        {
          src:'https://aus-auportal.oss-cn-shanghai.aliyuncs.com/file/updata/a58e5a667af548b5b4e39fe5f25780bc.png',
        },
      ],
      messageType: '待办',
      tableData: [],
      day: '',
      popoverVisible: false,
      scheduleList: [],
      originalList: [],
      meetingRoomList: [],
      form: {
        scheduleType: 'schedule',
        teminderTypeCode: ['15'],
        
        personData: [],
      },
      remindSelect: [
        {
          label: '准时',
          value: '0'
        },
        {
          label: '提前五分钟',
          value: '5'
        },
        {
          label: '提前十分钟',
          value: '10'
        },
        {
          label: '提前十五分钟',
          value: '15'
        },
        {
          label: '提前三十分钟',
          value: '30'
        },
        {
          label: '提前一小时',
          value: '60'
        },
        {
          label: '提前两小时',
          value: '120'
        },
        {
          label: '提前一天',
          value: '1440'
        },
      ],
      userSelectConfig: {
        dialogVisible: false,
        type: 'person'
      },
      flowList: [],
      applyList: [],
      flowType: '待办',
      user:JSON.parse(localStorage.getItem('user')),
      meetingDatas:[],
      curMeeting:null,
      meetingForm:{},
      replyDialogFormVisible:false,
      entrustDialogFormVisible:false,
      entrustUserSelectConfig: {
        dialogVisible: false,
        type: 'person'
      },
      visibilityTimer: null, // 防抖定时器

      lastTimeStamp: null, // 记录上次的时间戳
      activeSeconds: 0, // 累计活跃秒数
      timerFunc : null,
      curHref:'',
      // 事件监听器引用，用于正确卸载
      visibilityChangeHandler: null,
      webkitVisibilityChangeHandler: null,
      popstateHandler: null,
      focusHandler: null,
      todoLoading: false,
    }
  },
  computed: {
    entryDay() {
      let newDay = new Date().getTime()
      let entry = this.headInfo.userInfoResp?new Date(this.headInfo.userInfoResp.serviceDate).getTime():new Date().getTime()
      console.log(entry,'computed')
      return Math.floor((newDay - entry) / (24 * 60 * 60 * 1000))
    },
    localHref(){
      console.log('computed href',window.location.href)
      return window.location.href
    }
  },
  watch: {
    localHref(newVal, oldVal) {
      console.log(newVal, oldVal,'watch')
      if(newVal.indexOf('main')!=-1){
        console.log('监听111')
        this.handleVisibility()
      }
    }
  },
  activated(){
     this.handleVisibility()
  },
  filters: {
    filterNew: function(value) {
      if (!value) return;
      if (value.length <= 18) return value;
      let val = value.slice(0, 18) + '...'
      return val
    },
    filterTitle: function(value) {
      if (!value) return;
      if (value.length <= 6) return value;
      let val = value.slice(0, 6) + '...'
      return val
    },
    filterFlowName: function(value) {
      if (!value) return;
      if (value.length <= 18) return value;
      let val = value.slice(0, 18) + '...'
      return val
    },
  },
  mounted() {
    this.curHref = window.location.href
    // 标准 visibilitychange 事件（现代浏览器）
    if (typeof document.addEventListener !== 'undefined') {
      this.visibilityChangeHandler = () => {
        console.log('监听1')
        this.handleVisibility()
      }
      document.addEventListener('visibilitychange', this.visibilityChangeHandler)
    }

    this.webkitVisibilityChangeHandler = () => {
      console.log('监听s')
      this.handleVisibility()
    }
    document.addEventListener('webkitvisibilitychange', this.webkitVisibilityChangeHandler, false)

    // this.lastTimeStamp = Date.now();
    // let _this = this
    // this.timerFunc = setInterval(() => {
    //   const now = Date.now();
    //   if (this.lastTimeStamp) {
    //     const deltaMs = now - this.lastTimeStamp;
    //     const deltaSec = Math.floor(deltaMs / 1000);
       
    //      _this.activeSeconds ++
    //       console.log('实际时间差',deltaSec)
    //     console.log('计算时间差', _this.activeSeconds)
    //     console.log('curuUrl', window.location.href)
    //     console.log('isHidden', document.hidden)
    //     console.log('window.name',window.name);
    //     console.log('window',window);
    //     if (_this.activeSeconds < deltaSec) {
    //       console.log('重新计算')
    //       _this.lastTimeStamp = now;
    //       _this.activeSeconds = 0;
    //       _this.handleVisibility()
    //     }
       
    //   }
    // }, 1000);
    // 企业微信等环境兼容：使用 pageshow 事件
    // window.addEventListener('pageshow', ()=>{
    //     console.log('监听2')
    //     this.handleVisibility()
    //   },false)
 // 窗口焦点事件作为备选方案
    this.popstateHandler = () => {
      console.log('监听5')
      this.handleVisibility()
    }
    window.addEventListener('popstate', this.popstateHandler, false)

    // 窗口焦点事件作为备选方案
    // this.focusHandler = () => {
    //   console.log('监听3')
    //   this.handleVisibility()
    // }
    // window.addEventListener('focus', this.focusHandler, false)
    
    // 初始化时主动执行一次
    this.handleVisibility()
  },
  beforeDestroy() {
    // 清除防抖定时器
    if (this.visibilityTimer) {
      clearTimeout(this.visibilityTimer)
      this.visibilityTimer = null
    }
    if(this.timerFunc){
      clearInterval(this.timerFunc)
      this.timerFunc = null
    }
    
    // 移除所有事件监听
    if (typeof document.removeEventListener !== 'undefined') {
      if (this.visibilityChangeHandler) {
        document.removeEventListener('visibilitychange', this.visibilityChangeHandler)
        this.visibilityChangeHandler = null
      }
      if (this.webkitVisibilityChangeHandler) {
        document.removeEventListener('webkitvisibilitychange', this.webkitVisibilityChangeHandler)
        this.webkitVisibilityChangeHandler = null
      }
    }
    if (this.popstateHandler) {
      window.removeEventListener('popstate', this.popstateHandler)
      this.popstateHandler = null
    }
    if (this.focusHandler) {
      window.removeEventListener('focus', this.focusHandler)
      this.focusHandler = null
    }
  },
  created(){
    this.handleVisibility()
    if(this.isInWeCom()){
      console.log('判断是否在企微')
      this.openPortal()
    }
  },
  methods: {
    isInWeCom() {
      const ua = navigator.userAgent.toLowerCase();
      // 企业微信包含 wxwork 标识
      return ua.indexOf('wxwork') > -1;
    },
    isMacOSDesktop() {
      const ua = navigator.userAgent;
      const isMac = /Macintosh|MacIntel|MacPPC|Mac68K/.test(ua);
      const isMobile = /Mobile|iPhone|iPad|iPod/.test(ua);
      return isMac && !isMobile;
    },
    isIOSSafari() {
      const ua = navigator.userAgent || '';
      const isiOS = /iP(hone|od|ad)/i.test(ua);
      // 只对 iOS Safari 生效：排除 Chrome/Firefox 等内核浏览器
      const isSafari = /Safari/i.test(ua) && !/CriOS/i.test(ua) && !/FxiOS/i.test(ua);
      return isiOS && isSafari;
    },
    // 去除路径 # 号及其后面的所有内容
    prepareUrlForSignature(fullUrl) {
      return fullUrl.split('#')[0];
    },
    openPortal () {
      let localUrl = ''
      localUrl = window.location.href
      console.log('getSystemInfo', localUrl)
      this.$axios.post(this.global.BASE_URL + '/msi/qywx/info/conf/jsapi/sign',
        {
          data: {
            wechatCode: 'oa',
            url: this.prepareUrlForSignature(localUrl),
          },
          asp: this.global.asp,
        },
      ).then(res => {
        if (res.data.code === '0000') {
          console.log(res.data.data,'res.data.data')
            ww.register({
              corpId: res.data.data.appId,
              agentId:res.data.data.agentId,
              getConfigSignature:()=>{
                return {
                  timestamp: res.data.data.timestamp, 
                  nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
                  signature: res.data.data.signature
                } 
              },
              getAgentConfigSignature:()=>{
                return {
                  timestamp: res.data.data.timestamp, 
                  nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
                  signature: res.data.data.signature2
                } 
              }
            , // 必填，签名
            jsApiList: [
              'openDefaultBrowser',	
            ],
            debug: true
            })
            const doOpen = () => {
              ww.openDefaultBrowser({
                url: `${this.global.BASE_URL}/#/?token=${Cookies.get(`token_${window.location.port}`)}`,
                success: function (res) {
                  console.log('打开默认浏览器成功');
                  window.close()
                }
              })
            }

            // iOS Safari 会拦截“非用户触发”的自动跳转；仅 iOS Safari 弹窗确认
            if (this.isIOSSafari()) {
              this.$confirm('iOS 可能会拦截自动跳转，点击“确认”后将打开默认浏览器继续。', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning',
                center: true
              })
                .then(() => {
                  doOpen()
                })
                .catch(() => {})
            } else {
              doOpen()
            }
        }
      })	
    },
    // 启动仅在可见时运行的计数器
    startActiveInterval() {
      if (this._activeIntervalId) return;
      this._lastActiveTick = Date.now();
      this._activeIntervalId = setInterval(() => {
        const now = Date.now();
        const deltaMs = now - this._lastActiveTick;
        const deltaSec = Math.floor(deltaMs / 1000);
        if (deltaSec >= 1) {
          this.activeSeconds += deltaSec;
          // 将 lastTick 向前移动 deltaSec 秒
          this._lastActiveTick += deltaSec * 1000;
        }
      }, 1000);
    },

    rowKey(row){
      return row.id
    },
    handleVisibility() {
      // 防抖处理：避免频繁触发
      if (this.visibilityTimer) {
        clearTimeout(this.visibilityTimer)
      }
      
      this.visibilityTimer = setTimeout(() => {
        // 兼容性检查：优先使用 visibilityState，否则默认认为可见
        const isVisible = document.visibilityState 
          ? document.visibilityState === 'visible' 
          : !document.hidden || document.hidden === false
        
        if (isVisible) {
          this.getHeadInfo()
          this.getNew()
          this.getNotice()
          this.getMenus()
          this.getApp()
          if ( this.flowType === '待办') {
            this.myTask('/msi/flow/engine/process/myTasks')
          } else if ( this.flowType === '已办') {
            this.myTask('/msi/flow/engine/process/myCompletedTasks')
          } else if ( this.flowType === '待阅') {
            this.myTask('/msi/flow/engine/process/findFlowMsg',{messageStatus:20})
          } else if ( this.flowType === '已阅') {
            this.myTask('/msi/flow/engine/process/findFlowMsg',{messageStatus:50})
          }
          this.day = moment(new Date()).format('YYYY-MM-DD')
          this.initData(moment(new Date()).format('YYYY-MM-DD'))
          this.getMeetings()
        }
      }, 300) // 300ms 防抖延迟
    },
    acceptData(type){
      this.$confirm(`确认${type === 'agree'?'接受':'不接受'}日程?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          this.$axios.post(this.global.BASE_URL + '/msi/oa/schedule/adjustSchedule', {
          data:{scheduleId:this.form.id,status:type === 'agree'?50:20}
          }).then(res => {
              if (res.data.status === 'Y') {
                this.$message('操作成功')
                this.form = {
                  scheduleType: 'schedule',
                  personData: [],
                }
                this.popoverVisible= false
                this.initData()
              }
          })
        })
        .catch((error) => {
          console.log(error)
        })
    },
    returnColor(){
      let colorList = ['#0cc0c9', '#ffab24', '#2e9cff', '#ff6952']
      let colorList2 = ['rgba(12, 192, 201,.3)', 'rgba(255, 171, 36,.3)', 'rgba(46, 156, 255,.3)', 'rgba(255, 105, 82,.3)']
      const randomIndex = Math.floor(Math.random() * colorList.length)
      console.log(colorList[randomIndex],'colorList[randomIndex]')
      return {background:colorList[randomIndex],shadow:colorList2[randomIndex]}
    },
    isOptionDisabled(value){
      if(!this.form.teminderTypeCode){
        return false
      }else{
        return this.form.teminderTypeCode.length >= 3 && 
        !this.form.teminderTypeCode.includes(value)
      }
      
    },
    formateDateTime(date){
      return moment(new Date(date)).format('YYYY-MM-DD HH:mm')
    },

    openRefuseReply(curMeeting){
      this.curMeeting = curMeeting
      this.meetingData = {}
      this.replyDialogFormVisible = true
    },
    

    //拒绝参会提交
    refuseReply(){
      this.staffReply(this.curMeeting,'no',this.meetingForm.reason)
      this.replyDialogFormVisible = false
    },

    
    openEntrustReply(curMeeting){
      this.curMeeting = curMeeting
      this.meetingData = {}
      this.entrustDialogFormVisible = true
    },

    //委托提交
    entrustReply(){
      let staffObj ={
        userCode:this.meetingForm.entrustStaffCode,
        name:this.meetingForm.entrustStaffName,
      }
      this.staffReply(this.curMeeting,'entrust',this.meetingForm.reason,staffObj)
      this.entrustDialogFormVisible = false
    },

   //回执提交
    async staffReply(item,reply, reason = '', entrustStaff = null) {
        let this_=this
        console.log(this.meetingData,'meetingData.value')
        console.log(entrustStaff,'entrustStaff')
        const payload = {
          data: {
            bookingId: item.bookingId,
            reply,
            reason,
            entrustStaffCode: entrustStaff ? entrustStaff.entrustStaffCode || entrustStaff.code : '',
            entrustStaffName: entrustStaff ? entrustStaff.entrustStaffName  || entrustStaff.name : '',
          },
        }
        let res = await this.$axios.post(`${this.global.BASE_URL_2971}/msi/oa/meeting/meetingStaffReply`,payload)
        // uni.showToast({ title: '回执成功', icon: 'none' })
        if (res.data.code === '0000') {
          // hasStaffReply.value = true
          let title = '回执成功'
          if(reply == 'yes'){
            title = '已确定参加'
          }else if(reply == 'no'){
            title = '已确定不参加'
          }else if(reply == 'entrust'){
            title = '已委托'
          }
          this_.$message.success(title)
          this_.getMeetings()
          
        }
    },

    getMeetings(){
      this.$axios
        .post(`${this.global.BASE_URL_2971}/msi/oa/meeting/myMeeting`, {
          pageIndex: 0,
          pageSize: 9999,
          data:{status:20, replyList: [null,"yes"]}
        })
        .then((res) => {
          if (res.data && res.data.data) {
            this.meetingDatas = res.data.data
          }
        })
        .catch((err) => {
          console.error("加载会议室列表失败", err);
        })
    },

    updateCanlenderStatus(){
      console.log(this.form,'form')
      this.form.teminderTypeCode = this.form.teminderTypeCode.split(',')
      this.$set(this.form,'type','edit')
    },
    updateCanlender(t){
      let data = this.originalList.find(item => item.id == t.id)
      console.log(data,'ddds')
      this.form = data
      let formData = new FormData()
      formData.append('scheduleId',data.id)
      this.$axios.post(this.global.BASE_URL_2971+'/msi/oa/schedule/findAllScheduleStaff',formData)
        .then(res =>{
          if(res.data.code === '0000'){
            console.log(res)
            let personData = res.data.data.map(item => {
              item.name = item.userName
              item.id = item.userInfoId
              return item
            })
            this.$set(this.form,'personData',personData)
            this.$set(this.form,'type','view')
            this.openSche()
          }
        })
    },
    deleteCanlender(){
      this.$confirm("确认删除？","提示",{
        confirmButtonText:"确定",
        cancelButtonText:"取消",
        type:"warning",
        center:true,
      })
      .then(() => {
        let formData = new FormData()
        formData.append('id',this.form.id)
        this.$axios.post(this.global.BASE_URL_2971+'/msi/oa/schedule/deleteSchedule',formData)
          .then(res =>{
          if(res.data.code === '0000'){
            this.$message('删除成功')
            this.form = {
              scheduleType: 'schedule',
              personData: [],
            }
            this.popoverVisible = false
            this.initData(moment(this.day).format('YYYY-MM-DD'))
          }
        })
      })
      .catch((error) => {
        console.log(error);
      });
    },
    sureCanlender(){
      if(!this.form.teminderTypeCode || this.form.teminderTypeCode.length === 0){
        this.$message.warning('请选择提醒时间')
        return ;
      }
      if(!this.form.title){
        this.$message.warning('请填写主题')
        return ;
      }
      if(!this.form.startTime || !this.form.endTime){
          this.$message.warning('开始时间结束时间必填')
          return ;
      }
      if(this.form.startTime && this.form.endTime && (new Date(this.form.startTime).getTime() >= new Date(this.form.endTime).getTime())){
          this.$message.warning('结束时间不能早于开始时间')
          return ;
      }
      // if(!this.form.content){
      //   this.$message.warning('请填写内容')
      //   return ;
      // }
      let user = JSON.parse(localStorage.getItem('user'))
      console.log(this.form.personData,'this.form.personData')
      if(this.form.personData.findIndex(item => item.id == user.userInfoId) === -1){
        this.form.personData.push({id:user.userInfoId,name:user.userName})
      }
      let newArr = this.form.personData.map(item =>item.id)
      let data = {
        data:{
          ...this.form,
          startTime: moment(this.form.startTime).format('yyyy-MM-DD HH:mm:ss'),
          endTime: moment(this.form.endTime).format('yyyy-MM-DD HH:mm:ss'),
          teminderTypeCode: this.form.teminderTypeCode? this.form.teminderTypeCode.join(','):'',
          teminderTypeName: this.form.teminderTypeCode.map(item => this.remindSelect.find(t => t.value === item).label).join(','),
          staffIds: [...new Set(newArr)]
        }
      }
      let url = ''
      if(this.form.id){
        url = this.global.BASE_URL_2971+'/msi/oa/schedule/updateSchedule'
      }else{
        url = this.global.BASE_URL_2971+'/msi/oa/schedule/insertSchedule'
      }
      this.$axios.post(url,data)
        .then(res =>{
          if(res.data.code === '0000'){
            this.$message('新增日程成功')
            this.form = {
              scheduleType: 'schedule',
              personData: [],
            }
            this.popoverVisible = false
            this.initData(moment(this.day).format('YYYY-MM-DD'))
          }
        })
    },
    clearShow(){
      this.form = {
        scheduleType: 'schedule',
        personData: [],
        teminderTypeCode:['15']
      }
    },
    showPopover(){
      if(this.meetingRoomList.length === 0){
        this.getMeeting()
      }
      console.log(this.form.teminderTypeCode,'this.form.teminderTypeCode')
      this.$nextTick(()=>{
        this.$forceUpdate()
      })
    },
    openSche(){
      this.popoverVisible = true
      console.log(this.popoverVisible,'openSche')
    },
    getMeeting(){
      this.$axios.post(this.global.BASE_URL_2971 + '/msi/oa/meeting/room/findMeetingRoom', {
          data:{status:50,meetingRoomStatus: '50'},pageIndex:0,pageSize:999
      }).then(res => {
        if (res.data.status === 'Y') {
          this.meetingRoomList = res.data.data
          console.log(this.meetingRoomList,'this.meetingRoomList')
        }
      })
    },
    initData (month) {
      this.$axios.post(this.global.BASE_URL_2971 + '/msi/oa/schedule/findAllScheduleNew', {
       data:{month:month.slice(0,7)}
      }).then(res => {
        if (res.data.status === 'Y') {
          this.scheduleList = []
          this.originalList =  res.data.data
          this.scheduleList = this.splitDataByDay(res.data.data);
          console.log(7878,this.scheduleList)
        }
      })
    },
    // 重置日期格式
    splitDataByDay(originalData) {
      const resultMap = new Map(); // 使用 Map 按天存储数据

      originalData.forEach(item => {
        const startDate = new Date(item.startTime);
        const endDate = new Date(item.endTime);

        // 如果开始和结束是同一天
        if (isSameDay(startDate, endDate)) {
          const dateKey = getDateKey(startDate);
          addToMap(resultMap, dateKey, item);
        } else {
          // 跨天的情况，需要拆分
          let currentDate = new Date(startDate);
          
          while (currentDate <= endDate) {
            const dateKey = getDateKey(currentDate);
            const isFirstDay = currentDate.getTime() === startDate.getTime();
            const isLastDay = isSameDay(currentDate, endDate);

            // 创建当天的部分数据
            const dayItem = {
              ...item,
              startTime: isFirstDay ? item.startTime : getDayStart(currentDate).getTime(),
              endTime: isLastDay ? item.endTime : getDayEnd(currentDate).getTime(),
              isPartial: !(isFirstDay && isLastDay) // 标记是否为部分数据
            };

            addToMap(resultMap, dateKey, dayItem);

            // 移动到下一天
            currentDate.setDate(currentDate.getDate() + 1);
            currentDate = getDayStart(currentDate); // 重置为下一天的开始
          }
        }
      });

      // 将 Map 转换为排序后的数组
      return Array.from(resultMap.entries())
        .sort((a, b) => a[0] - b[0])
        .map(([date, items]) => ({
          date: date,
          items: items.sort((a, b) => a.startTime - b.startTime)
        }));

      // 辅助函数：判断两个日期是否是同一天
      function isSameDay(date1, date2) {
        return getDateKey(date1) === getDateKey(date2);;
      }

      // 辅助函数：获取日期的键（当天0点的时间戳）
      function getDateKey(date) {
        return moment(date).format('YYYY-MM-DD')
      }

      // 辅助函数：获取当天的开始时间（0点）
      function getDayStart(date) {
        const newDate = new Date(date);
        newDate.setHours(0, 0, 0, 0);
        return newDate;
      }

      // 辅助函数：获取当天的结束时间（23:59:59.999）
      function getDayEnd(date) {
        const newDate = new Date(date);
        newDate.setHours(23, 59, 59, 999);
        return newDate;
      }

      // 辅助函数：将数据添加到 Map 中
      function addToMap(map, key, item) {
        item.startTime = changeTimeRow(item.startTime)
        item.endTime = changeTimeRow(item.endTime)
        if (!map.has(key)) {
          map.set(key, []);
        }
        map.get(key).push(item);
      }

      // 辅助函数：将Map中的数据格式化
      function changeTimeRow(data) {
        return moment(data).format('YYYY-MM-DD HH:mm')  
      }
    },
    getMenus(){
        this.$axios.post(this.global.BASE_URL+'/msi/flow/engine/process/findCommonProcess',
          {data:{},pageIndex:0,pageSize:10})
          .then(res => {
              if(res.data.code === '0000'){
                  this.flowList = res.data.data.map(item => {
                    const  color= getUserColor(item);
                    item.background = color.backgroundColor;
                    item.shadow = color.BoxShadowColor;
                    return item
                  })
                  console.log(this.flowList,'this.flowList')
              }
          })
    },
    goCanlender(){
      window.open(this.global.BASE_URL_2971+'/#/oaSystem/schedulerCanlendar','_blank');
    },
    async goApp(t){
      let flag = await this.verifyToken()
      if(flag){
        if(t.systemType === 'internal'){
          if(t.systemId === 1){
            console.log(this.global.BASE_URL_2971+'/#/index?token=' + Cookies.get(`token_${window.location.port}`)+'&systemId='+t.systemId+'&systemCode=oaSystem')
            window.open(this.global.BASE_URL_2971+'/#/index?token=' + Cookies.get(`token_${window.location.port}`)+'&systemId='+t.systemId+'&systemCode=oaSystem','_blank');
          }else{
            console.log(t.systemUrl+'?ticket='+Cookies.get(`token_${window.location.port}`)+'&systemId='+t.systemId+'&systemCode='+t.systemCode+'&token=' + Cookies.get(`token_${window.location.port}`))
            window.open(t.systemUrl+'?ticket='+Cookies.get(`token_${window.location.port}`)+'&systemId='+t.systemId+'&systemCode='+t.systemCode+'&token=' + Cookies.get(`token_${window.location.port}`),'_blank');
          }
        }else if(t.systemType === 'external'){
          this.$axios.post(this.global.BASE_URL_2971 + t.systemUrl,{}).then(res=>{
            if(res.data.status === 'Y'){
              console.log(res.data.data)
              if(t.systemId === 104){
                window.open('http://10.0.0.181:8089/api/sso?token='+res.data.data,'_blank');
              }else if(t.systemId === 106){
                console.log(res.data.data,'ddd')
                window.open(res.data.data,'_blank');
              }
            }
          })
        }
      }
    },
    async verifyToken(){
      let res = await this.$axios.post(this.global.BASE_URL_2971 + "/msi/base/info/system/findMySystem",{
        data: {
        },
        pageIndex: 0,
        pageSize: 99,
      })
      console.log(res,'res')
      if(res.data.status === 'Y'){
        console.log('-------token没问题---------')
        return true
      }else{
        return false
      }
    },
    goProcess(){
      let route = this.$router.resolve({ path: `/systemList`  });
      window.open(route.href, '_blank');
    },
    getApp(){
        this.$axios.post(this.global.BASE_URL+'/msi/base/info/system/findMySystem',
          {data:{},pageIndex:0,pageSize:10})
          .then(res => {
              if(res.data.code === '0000'){
                  // this.applyList = res.data.data.splice(0,8)
                  this.applyList = res.data.data.splice(0,4)
              }
          })
    },
    goAdd(item){
      if(item){
        window.open(this.global.BASE_URL_2971+'/#/portal'+item.flowCode+'?name='+item.flowName+'&formVersion='+item.formVersion+'&token=' + Cookies.get(`token_${window.location.port}`),'_blank');
      }else{
        window.open(this.global.BASE_URL_2971+'/#/oaSystem/initiateApproval?toDo=true&token=' + Cookies.get(`token_${window.location.port}`),'_blank');
      }
      
      // window.open('http://localhost:3000/#/portal'+item.flowCode+'?name='+item.flowName,'_blank');
    },
    changeTime (row, column) {
      let date = row[column.property]
      if (date === undefined) {
        return ''
      }
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    goFlow(){
      this.$router.push({name:"flow"})
    },
    async getFlowUrlSeting(flowCode){
        const searchParams = window.location.search.substring(1).split('&');
        const params = {};
          for (const param of searchParams) {
          const [key, value] = param.split('=');
          params[key] = value;
        }
        let formData = {
          data:{
            flowCode:flowCode,
          }
        }
        let res =  await this.$axios.post(`${this.global.BASE_URL}/msi/flow/design/flow/findFlowConf`,formData,{
            headers: {
              'certificate':params.auth // 使用 Authorization 头部传递 token
            }
        })
        if(res.data.data){
          let resData = res.data.data
          if(resData.pcPageUrl){
            return resData.pcPageUrl
          }else{
            return ''
          }
        }
        return ''
    },
    async goFlowDetail(item){
      let pageUrl = await this.getFlowUrlSeting(item.flowCode)
      let name = pageUrl.split('/')[pageUrl.split('/').length - 1]
      item.applyTime = moment(item.applyTime).format("yyyy-MM-DD HH:mm:ss");
      item.createTime = moment(item.applyTime).format("yyyy-MM-DD HH:mm:ss");
      if(this.flowType == '待阅' || this.flowType == '已阅'){
        item.nodeId =  item.nodeId || item.firstActivityId
      }
      let todo = ''
      let systemId = 0
      let systemCode = ''
      if(['拜访管理','销售管理系统','流向管理','营销线考勤'].includes(item.typeName)){
        systemId = 103
        systemCode = 'saleSystem'
      }else{
        systemId = 1
        systemCode = 'oaSystem'
      }
      if(this.flowType == '待办'){
        if(pageUrl == '' || item.formCategory == 'external'){
          if(item.formCategory == 'external') item.pageUrl = pageUrl
          todo = encryptDes(JSON.stringify(item))
          window.open(this.global.BASE_URL_2971+'/#/MyApprovalPend?toDo='+todo+'&token=' + Cookies.get(`token_${window.location.port}`)+'&systemId='+systemId+'&systemCode='+systemCode,'_blank');
        }else{
          todo = encryptDes(JSON.stringify(item))
          window.open(this.global.BASE_URL_2971+`/#/${name}Pend?toDo=`+todo+'&token=' + Cookies.get(`token_${window.location.port}`)+'&systemId='+systemId+'&systemCode='+systemCode,'_blank');
        }
          // window.open('http://localhost:3000/#/MyApprovalPend?toDo='+todo,'_blank');
      }else if(this.flowType == '已办'){
        if(pageUrl == '' || item.formCategory == 'external'){
          if(item.formCategory == 'external') item.pageUrl = pageUrl
          todo = encryptDes(JSON.stringify(item))
          window.open(this.global.BASE_URL_2971+'/#/MyApprovalView?toDo='+todo+'&token=' + Cookies.get(`token_${window.location.port}`)+'&systemId='+systemId+'&systemCode='+systemCode,'_blank');
        }else{
          todo = encryptDes(JSON.stringify(item))
          window.open(this.global.BASE_URL_2971+`/#/${name}View?toDo=`+todo+'&token=' + Cookies.get(`token_${window.location.port}`)+'&systemId='+systemId+'&systemCode='+systemCode,'_blank');
        }
          // window.open('http://localhost:3000/#/MyApprovalView?toDo='+todo,'_blank');
      }else{
        if(pageUrl == '' || item.formCategory == 'external'){
          if(item.formCategory == 'external') item.pageUrl = pageUrl
          todo = encryptDes(JSON.stringify(item))
          window.open(this.global.BASE_URL_2971+'/#/myCopyView?toDo='+todo+'&token=' + Cookies.get(`token_${window.location.port}`)+'&systemId='+systemId+'&systemCode='+systemCode,'_blank');
        }else{
          todo = encryptDes(JSON.stringify(item))
          window.open(this.global.BASE_URL_2971+`/#/${name}View?toDo=`+todo+'&token=' + Cookies.get(`token_${window.location.port}`)+'&systemId='+systemId+'&systemCode='+systemCode,'_blank');
        }
          // window.open('http://localhost:3000/#/myCopyView?toDo='+todo,'_blank');
      }

      if(item.msgCode){
        let formData = new FormData()
        formData.append('msgCode', item.msgCode)
        this.$axios.post(this.global.BASE_URL + '/msi/base/info/message/readMessage', formData)
        .then((res) => {
          console.log(res, 'readMessage')
        })
      }
    },

    goMyMeetig(item){
      window.open(this.global.BASE_URL_2971 + '/#/IJoinMeeting?toDo=true'+'&token=' + Cookies.get(`token_${window.location.port}`),'_blank');
    },

    goMeetigDetail(item){
      let todo = encryptDes(JSON.stringify(item))
      window.open(this.global.BASE_URL_2971 + '/#/IJoinMeeting?toDo='+todo+'&token=' + Cookies.get(`token_${window.location.port}`),'_blank');
    },

    toBookMeeting(){
      window.open(this.global.BASE_URL_2971 + '/#/IJoinMeeting?toBook=true&toDo=10'+'&token=' + Cookies.get(`token_${window.location.port}`),'_blank');
    },

    getHeadInfo() {
      this.$axios.post(this.global.BASE_URL_2971 + '/msi/flow/engine/task/findTaskCount', { data: {} })
        .then(res => {
          if (res.data.code === '0000') {
            console.log(res.data.data)
            this.headInfo = res.data.data
          }
        })
    },
    getNew() {
      this.$axios.post(this.global.BASE_URL_2971 + '/msi/cms/web/article/findWebArticleRealTime', { data: {} })
        .then(res => {
          if (res.data.code === '0000') {
            console.log(res.data.data)
            this.news = res.data.data.news
            this.picUrls = res.data.data.focus
            this.$axios.post(this.global.BASE_URL_2971 + '/msi/cms/web/article/findWebNotice', { data: {},pageIndex:0,pageSize:3 })
            .then(res1 => {
              if (res1.data.code === '0000') {
                console.log(res1.data.data)
                this.notices = res1.data.data
              }
            })
          }
        })
    },
    getNotice() {
      let data = {
        asp: JSON.parse(localStorage.getItem('user')).asp,
        data: {
          location: 'homePage',
          siteCode: 'W',
          status: '50'
        },
        pageIndex: 0,
        pageSize: 10,
      }
      this.$axios.post(this.global.BASE_URL_2971 + '/msi/cms/web/adpic/findWebAdpic', data)
        .then(res => {
          if (res.data.code === '0000') {
            console.log(res.data.data)
            this.noticeBanner = res.data.data
          }
        })
    },
    newList(type) {
      let route = ''
      if(type === 'new'){
        route = this.$router.resolve({ path: `/noticeLists`  });
      }else{
        route = this.$router.resolve({ path: `/newsList/${type}`  });
      }
      window.open(route.href, '_blank');
    },
    newDetail(item) {
      // this.$router.push({ name:'news', path:`/news/${item.articleId}` })
      const route = this.$router.resolve({ path: `/news/${item.articleId}`  });
      window.open(route.href, '_blank');
    },
    changeRadio(val) {
      console.log(val, 'cal')
      this.flowType = val
      if (val === '待办') {
        this.myTask('/msi/flow/engine/process/myTasks')
      } else if (val === '已办') {
        this.myTask('/msi/flow/engine/process/myCompletedTasks')
      } else if (val === '待阅') {
        this.myTask('/msi/flow/engine/process/findFlowMsg',{messageStatus:20})
      } else if (val === '已阅') {
        this.myTask('/msi/flow/engine/process/findFlowMsg',{messageStatus:50})
      }
    },
    myTask(url,params) {
      this.todoLoading = true
      let data = {
        asp: JSON.parse(localStorage.getItem('user')).asp,
        data: {
          ...params
        },
        pageIndex: 0,
        pageSize: 6 ,
      }
      this.$axios.post(this.global.BASE_URL_2971 + url, data)
        .then(res => {
          if (res.data.code === '0000') {
            this.tableData = res.data.data.map(item => {
              if(params){
                // item.applyUserName = item.senderName
                item.applyTime = item.modifyTime
              }
              return item
            })
          }
        }) .finally(() => {
          this.todoLoading = false
        })
    },
    changeDay(data) {
      return moment(data).format('YYYY-MM-DD')  
    },
    changeDayTime(data){
      if(data){
        let time = new Date(data)
        return moment(time).format('YYYY-MM-DD HH:mm:ss')
      }else{
        return ''
      }
    },
    openUser(){
      this.userSelectConfig.dialogVisible = true;
    },
    cancelData(){
      this.userSelectConfig.dialogVisible = false;
      setTimeout(()=>{
        this.openSche()
      },200)
    },
    confirmUser(ids,datas,allData){
      console.log(allData,'data',this.form)
      this.form.personData = []
      allData.forEach((item, index)=>{
        this.form.personData.push({name:item.name,id:item.id})
      })
      this.userSelectConfig.dialogVisible = false;
      setTimeout(()=>{
        this.openSche()
      },200)
    },

    confirmEntrustUser(ids,datas,allData){
      console.log(allData,'data',this.meetingForm)
      // allData.forEach((item, index)=>{
      //   this.form.personData.push({name:item.name,id:item.id})
      // })
      this.meetingForm.entrustStaffCode = allData.map(item => item.code).join(',') || ''
      this.meetingForm.entrustStaffName = allData.map(item => item.name).join(',') || ''
      this.entrustUserSelectConfig.dialogVisible = false;
      // setTimeout(()=>{
      //   this.openSche()
      // },200)
    },
    handleCloseTag(index) {
      this.form.personData.splice(index,1)
    },
    clickOne(data) {
      // let solar = Solar.fromDate(new Date(data.day))
      // let lunar = solar.getLunar().toFullString();
      // this.day = (lunar.split('日')[0].slice(5) + '日').replace(/\([^)]+\)(?=月)|\([^)]+\)(?=日)/g, "")
      if(data)this.day = data.day
      // console.log('one',lunar, this.day)
      this.initData(this.day)
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-radio-button__inner {
  margin: 6px 20px !important;
  padding: 2px 0 !important;
  border: none !important;
  color: #83808F;
}
/deep/ .el-radio-button__inner:hover {
  color:#bb0009;
}
.is-active /deep/ .el-radio-button__inner{
  background-color: #fff !important;
  box-shadow: none !important;
  color:#bb0009;
  border-radius: 0px;
  border-bottom: 1px solid#bb0009 !important;
}
.is-active /deep/ .el-radio-button__inner:hover{
  color:#bb0009;
  border-radius: 0px;
  // border-bottom: 2px solid#bb0009 !important;
}
/deep/ .el-tag {
    // color: #c7180c;
    // border-color: #c7180c;
    color: #b40005;
    border-color: #ff9d8a;
    background-color:rgba(255,157,138,.2);
    font-size: 10px;
    margin-top: 2px;
    margin-left: 6px;
}
/* /deep/ .el-table__row:hover,/deep/ .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell  {
    background-color:#fff5f3;
} */

.body-message_table {

  /deep/ .el-table__body tr:hover > td {
    background-color: #fff5f3 !important;
  }

  /* 不对表头 hover 生效 */

  /deep/ .el-table__header tr:hover > th {
    background: inherit !important;
  }

  /* 关闭背景过渡，避免闪烁 */
  /deep/ .el-table__row > td {
    transition: background-color 0s !important;
  }

  /* 防止某些主题对整行设置背景导致叠加 */
  /deep/ .el-table__row:hover {
    background: transparent !important;
  }
}

/deep/ .el-tag__close {
    color: #c7180c !important;
}
/deep/ .el-calendar__header {
  padding-top: 0px !important;
}
.body-container {
  font-family: "-apple-system",BlinkMacSystemFont,"Segoe UI","PingFang SC","Hiragino Sans GB",STHeitiSC,Helvetica,"Helvetica Neue","Microsoft YaHei",Tahoma;
  font-size: 10px;
  display: block;
  padding-bottom: 16px;
  position: relative;
  
  background: linear-gradient(to bottom, #aaaeb1, #eeeeee);

  .body-main {
    padding: 0px;

    .body-header {
      margin-bottom: 10px;

      /deep/ .el-carousel__arrow {
        display: none;
      }
      /deep/ .el-carousel__indicators {
        display: none;
      }
    }

    .body-main_center {
      display: flex;
      min-height: calc(100% - 167px);
      // width: 1220px;

      .body-main_one {
        width: 450px;
        margin: 0 auto;
        min-height: 550px;
        border-radius: 12px;

        .list-content {
          background-color: #fff;
          padding: 15px;
          border-radius: 8px;
          
          .list-body {
            min-height: 138px;
            font-size: 12px;
            margin:0 10px;

            .list-item:hover {
              color:#bb0009;
            }

            .list-item {
              display: flex;
              -webkit-box-pack: justify;
              -ms-flex-pack: justify;
              justify-content: space-between;
              -webkit-box-align: center;
              -ms-flex-align: center;
              align-items: center;
              font-size: 12px;
              padding: 5px 0 5px;
              cursor: pointer;
              border-bottom: 0.5px solid #eaeaea;
              height: 30px;
              line-height: 30px;

              .el-tag {
                padding: 4px;
                background:#bb0009;
                border-radius: 4px;
                color: #fff;
                font-size: 10px;
                line-height: 10px;
                height: 20px;
              }

              div:last-child {
                line-height: 14px;
                text-align: right;
                color: #bebebe;
                -ms-flex-negative: 0;
                flex-shrink: 0;
              }
            }

            

            .list-item_canlendar {
              background-color: #fff;
              border-radius: 16px;
              position: relative;
              height: 475px;

              .canlendar-option {
                height: 39px;
                color: #83898f;
                border: 1px solid #e6e8eb;
                text-align: center;
                position: absolute;
                right: 20px;
                bottom: 0px;
              }

              .canlendar-option:hover {
                background-color: rgba(255,137,138,.3);
                border-color:rgb(255,137,138);
                color: rgb(255,137,138);
              }

              .canlendar-lunar {
                margin-left: 32px;
                font-size: 12px;
                line-height: 18px;
                color: #59575f;
              }

              .canlendar-item {
                display: flex;
                margin-bottom: 10px;

                .canlendar-left {
                  margin-right: 20px;
                  margin-left: 30px;
                  font-size: 12px;
                  font-weight: 500;
                  width: 20px;
                }

                .canlendar-right {
                  font-size: 10px;
                  line-height: 1.5;

                  .canlendar-day {
                    color: #999;
                  }
                }
              }

              .canlendar-item:hover {
                cursor: pointer;
              }
            }
          }
        }

        .list-title {
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;

          .list-title_bold {
            font-size: 22px;
            color: #59575f;
            font-weight: bold;
            height: 30px;
            line-height: 30px;
            display: flex;
            padding: 5px 15px;
            cursor: pointer;

            span {
              color: #59575f;
              font-size: 10px;
              display: -webkit-box;
              display: -ms-flexbox;
              display: flex;
              -webkit-box-align: end;
              -ms-flex-align: end;
              align-items: flex-end;
              margin-left: 2px;
              line-height: 24px;
            }
          }

          .list-title_bold:hover {
            font-size: 22px;
            color: #ffffff;
            font-weight: bold;
            height: 30px;
            line-height: 30px;
            display: flex;
            background: linear-gradient(to right,#bb0009, #e52030);;
            padding: 5px 15px;
            border-radius:  0 0 10px 0;

            span {
              color: #ffffff;
              font-size: 10px;
              display: -webkit-box;
              display: -ms-flexbox;
              display: flex;
              -webkit-box-align: end;
              -ms-flex-align: end;
              align-items: flex-end;
              margin-left: 2px;
              line-height: 24px;
            }
          }

          .list-title_more {
            color: #505050;
            cursor: pointer;
            line-height: 30px;
          }

          .list-title_more:hover {
            color:#bb0009;
          }
        }
      }

      .body-main_two {
        width: 750px;
        margin: 0 auto;
        margin-right: 6px;
        display: flex;
        margin-left: 10px;

        .body-main_left {
          margin-right: 35px;

          .body-model {
            display: flex;
            width: 750px;
            margin-bottom: 16px;

            .body-model_special {
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              cursor: unset;
              padding: 16px;
              -webkit-box-flex: 1;
              -ms-flex: 1;
              flex: 1;
              background: linear-gradient(0deg, #fff, #fff),radial-gradient(171.35% 317.19% at 35.24% -44.79%, #e3fdf5 0%, #ffe6fa 100%);
              -webkit-box-orient: vertical;
              -webkit-box-direction: normal;
              flex-direction: column;
              -webkit-box-pack: justify;
              justify-content: space-between;
              border-radius: 12px;
              margin-right: 16px;

              .body-special_avatar {
                display: flex;
                margin-top: 5px;

                div {
                  margin-left: 5px;
                  color: #a9b8bf;
                }
              }
            }

            .body-model_block {
              display: flex;
              -webkit-box-orient: vertical;
              -webkit-box-direction: normal;
              flex-direction: column;
              -webkit-box-pack: center;
              justify-content: center;
              width: 154px;
              height: 112px;
              background: linear-gradient(69.85deg, #deedff 1.87%, #f7f3ef 99.3%);
              box-shadow: 1px 0px 5px rgba(0,0,0,0.05);
              border-radius: 12px;
              margin-right: 16px;
              cursor: pointer;
              text-align: center;

              div {
                color: #058ACF;
                font-size:30px;
                font-weight: 700;
              }
            }
          }

          .body-message {
            width: 750px;
            padding: 10px 0;
            min-height: 350px;
            border-radius: 8px;

            .card-item {
              text-align: center;
              // background-color: #EBEEF5;
              position: relative;

              /deep/ .el-card__body {
                padding: 0 5px !important;
                height: 94px !important;
              }
              .el-avatar:hover{
                box-shadow:2px 8px 15px 0 var(--shadow-color);
                /deep/  img {
                  width:30px !important;
                  height: 30px !important;
                  margin-left: 10px !important;
                  margin-top: 10px !important;
                }
              }
              .el-avatar{
                margin-top: 12px;
                background-color: var(--background-color);

                /deep/  img {
                  width:25px !important;
                  height: 25px !important;
                  margin-left: 12.5px !important;
                  margin-top: 12.5px !important;
                  transition: ease .3s;
                }
                /deep/ .el-icon-more {
                  width:25px !important;
                  height: 25px !important;
                  color: #83898f !important;
                  transition: ease .3s;
                }
                
                /deep/ .el-icon-more:hover {
                  // font-size:30px !important;
                  // margin-top: 10px !important;
                  // margin-left: -6px !important;
                  transform: scale(1.2);
                }
              }

              div{
                font-size: 10px;
              }
            }

            .apply-list {
              padding: 10px 0 0 0;
              .apply-item {
                cursor: pointer;
                height: 90px;
                line-height: 90px;
                border-radius: 13px;
                border: 1px solid #eaeaea;
                display: flex;
                transition: ease .3s;
                img{
                  transform: scale(1);
                  transition: ease .3s;
                }
                div {
                  margin-left: 10px;
                }
              }
              .apply-item:hover{
                box-shadow: 2px 8px 15px 0 rgba(0,0,0,.04);
                img{
                  transform: scale(1.2);
                }
              }
            }

            .list-title {
              display: flex;
              justify-content: space-between;
              margin-right: 20px;
              margin-bottom: 10px;

              .list-title_bold {
                font-size: 22px;
                color: #59575f;
                font-weight: bold;
                height: 30px;
                line-height: 30px;
                display: flex;
                padding: 5px 15px;
                cursor: pointer;

                span {
                  color: #59575f;
                  font-size: 10px;
                  display: -webkit-box;
                  display: -ms-flexbox;
                  display: flex;
                  -webkit-box-align: end;
                  -ms-flex-align: end;
                  align-items: flex-end;
                  margin-left: 2px;
                  line-height: 24px;
                }
              }

              .list-title_bold:hover {
                font-size: 22px;
                color: #ffffff;
                font-weight: bold;
                height: 30px;
                line-height: 30px;
                display: flex;
                background: linear-gradient(to right,#bb0009, #e52030);;
                padding: 5px 15px;
                border-radius:  0 0 10px 0;

                span {
                  color: #ffffff;
                  font-size: 10px;
                  display: -webkit-box;
                  display: -ms-flexbox;
                  display: flex;
                  -webkit-box-align: end;
                  -ms-flex-align: end;
                  align-items: flex-end;
                  margin-left: 2px;
                  line-height: 24px;
                }
              }

              .list-title_more {
                color: #505050;
                cursor: pointer;
                line-height: 30px;
              }

              .list-title_more:hover {
                color:#bb0009;
              }
            }

            .body-message_title {
              display: flex;
              justify-content: space-between;

              .el-radio-group {
                border-radius: 100px;

                /deep/ .el-radio-button__inner {
                  margin: 6px 20px !important;
                  padding: 2px 0 !important;
                  border: none !important;
                  color: #83808F;
                }
                /deep/ .el-radio-button__inner:hover {
                  color:#bb0009;
                }
                .is-active /deep/ .el-radio-button__inner{
                  background-color: #fff !important;
                  box-shadow: none !important;
                  color:#bb0009;
                  border-radius: 0px;
                  border-bottom: 1px solid#bb0009 !important;
                }
                .is-active /deep/ .el-radio-button__inner:hover{
                  color:#bb0009;
                  border-radius: 0px;
                  // border-bottom: 2px solid#bb0009 !important;
                }

                span {
                  margin-left: 4px;
                }
              }

              .el-icon-top-right {
                height: 28px;
                line-height: 28px;
                width: 28px;
                text-align: center;
                font-size: 24px;
                background: #f0f2f5;
                border-radius: 8px;
              }

            }

            .body-message_table {
              margin-top: 12px;
              color:#0e1114;
              font-family:"-apple-system",BlinkMacSystemFont,"Segoe UI","PingFang SC","Hiragino Sans GB",STHeitiSC,Helvetica,"Helvetica Neue","Microsoft YaHei",Tahoma;
              /deep/ .el-tag {
                padding: 0 5px;
                line-height: 24px;
                height: 24px;
              }

            /deep/ .message_table--status {
                border-bottom: none !important;
                
              }
            }

            .el-table::before {
              height: 0;
            }
            .process:hover{
              color:#b40005;
            }
          }
        }
      }

    }
  }

  .footCss {
    position: absolute;
    bottom: 0;
    width: 1210px;
    margin: 0 auto;
    left: 0;
    right: 0;
    height: 106px;
    box-sizing: border-box;
    background: url(../../assets/images/red-footer-background.png) no-repeat;
    background-size: 100% 100%;
  }
  
}

 /deep/ .el-carousel__button{
    background-color: #83808F;
  }
  /deep/ .el-carousel__indicator.is-active button {
    opacity: 1;
    background-color:#bb0009;
  }
  .list-title_bold {
    font-size: 22px;
    color: #59575f;
    font-weight: bold;
    height: 30px;
    line-height: 30px;
    display: flex;
    padding: 5px 15px;
    cursor: pointer;

    span {
      color: #59575f;
      font-size: 10px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: end;
      -ms-flex-align: end;
      align-items: flex-end;
      margin-left: 2px;
      line-height: 24px;
    }
  }

  .list-title_bold:hover {
    font-size: 22px;
    color: #ffffff;
    font-weight: bold;
    height: 30px;
    line-height: 30px;
    display: flex;
    background: linear-gradient(to right,#bb0009, #e52030);;
    padding: 5px 15px;
    border-radius:  0 0 10px 0;

    span {
      color: #ffffff;
      font-size: 10px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: end;
      -ms-flex-align: end;
      align-items: flex-end;
      margin-left: 2px;
      line-height: 24px;
    }
  }


  /deep/ .el-carousel__indicators{
    max-height: 30px;
    overflow: hidden;
  }
  .meeting-box{
    display: flex;
    flex-direction: column;
    justify-content: start;
    padding-top: 40px;
    margin: 15px;
    cursor: pointer;
  }
  .meeting-title{
    font-weight: bold;
    font-size: 18px;
    color: #59575f;
    width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    margin-bottom: 10px;
  }
  .meeting-text{
    font-size: 12px;
    line-height: 24px;
  }
  .sure-button-box{
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 1;
    white-space: nowrap;
    background: #FFF;
    border: 1px solid #DCDFE6;
    color: rgb(169, 184, 191);
    -webkit-appearance: none;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    -webkit-transition: .1s;
    transition: .1s;
    font-weight: 500;
    padding: 12px 20px;
    font-size: 12px;
    padding: 0px 16px;
    font-size: 12px;
    border-radius: 0 0 10px 0;
    height: 30px;
    }
    .list-none-image {
    margin: 0 auto;
    text-align: center;
  }
  
  .list-none-font {
    font-size: 32rpx;
    color:#59575f;
    width: 100%;
    text-align: center;
    margin-top: 24px;
  }

  .el-date-editor /deep/.el-input__inner {
    padding-left: 0px !important;
}
.main_right--popover{
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 20px 0px;
}
.form-one{
  /deep/ .el-form-item__label{
    color:#83898f
  }
}
.el-date-editor /deep/.el-input__prefix{
    display:none 
  }
 ::v-deep .el-date-table td.current:not(.disabled) span{
  color:#fff!important;
  }
</style>


// WEBPACK FOOTER //
// src/views/main/index.vue